import { TextPostBodyWrapper } from './TextPostBodyWrapper.tsx';

export function TextPostBody({
  enlarged,
  html,
  text
}: {
  enlarged?: boolean;
  html?: string;
  text?: string;
}) {
  return (
    <TextPostBodyWrapper enlarged={enlarged}>
      {/* oxlint-disable-next-line react/no-danger */}
      {!!html && <div dangerouslySetInnerHTML={{ __html: html }} />}
      {!!text && <div className="whitespace-pre-wrap">{text}</div>}
    </TextPostBodyWrapper>
  );
}
